import { render, staticRenderFns } from "./ColInput.vue?vue&type=template&id=638b2653&scoped=true&"
import script from "./ColInput.vue?vue&type=script&lang=js&"
export * from "./ColInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b2653",
  null
  
)

export default component.exports